export default __webpack_public_path__ + "static/media/mural.a3add452.jpeg";